<template>
    <div class="tips-tricks-modal-wrapper" @click.self="closeModal">
        <div class="tips-tricks-modal">
            <div class="tips-tricks-modal__header">
                <h2 class="tips-tricks-modal__heading">{{ heading }}</h2>
                <button type="button" class="tips-tricks-modal__close-btn" @click.prevent="closeModal">
                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="tips-tricks-modal__close-icon">
                        <path
                            d="M22.875 2.41625L20.5837 0.125L11.5 9.20875L2.41625 0.125L0.125 2.41625L9.20875 11.5L0.125 20.5837L2.41625 22.875L11.5 13.7913L20.5837 22.875L22.875 20.5837L13.7913 11.5L22.875 2.41625Z"
                            fill="black" fill-opacity="0.54" />
                    </svg>
                </button>
            </div>

            <div class="tips-tricks-modal__body">
                <slot class="tips-tricks-modal__body"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TipsTricksModal',
    props: {
        heading: {
            type: String,
            required: true
        }
    },
    methods: {
        closeModal() {
            this.$emit('close-modal');
        }
    }
}
</script>